/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SafariAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function SafariAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Error/Content/SafariAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Safari (macOS)"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Guides/Safari'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Guides/Safari'))}
/>
{children}
</React.Fragment>)
}